module.exports = __webpack_public_path__ + "static/img/img_cloud@2x.3e65afd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img_cloud@2x.png
// module id = NWho
// module chunks = 0